// src/App.tsx
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { initFacebookTracking, trackPageView } from "./services/facebookAPI";
import HomePage from "./pages/HomePage";
import CheckoutPage from "./pages/CheckoutPage";
import ThankYouPage from "./pages/ThankYouPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "./App.css";
import ScrollToTop from "./pages/ScrollToTop";

// Component to track page views on route changes
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever the route changes
    trackPageView();
    
    // Log route changes for debugging
    console.log(`📍 Route changed to: ${location.pathname}`);
  }, [location]);

  return null;
};

function App() {
  const [orderDetails, setOrderDetails] = useState<any>(null);

  // Initialize Facebook Conversion API when app starts
  useEffect(() => {
    initFacebookTracking();
    
    console.log("🚀 The Peters Agriculture App Started");
    console.log("📊 Facebook Conversion API: Activated");
    
    // Optional: Log environment info (for debugging)
    if (process.env.NODE_ENV === "development") {
      console.log("🔧 Development Mode: Facebook events will be logged");
      console.log("🌐 Backend URL:", process.env.REACT_APP_BACKEND_URL || "http://localhost:5000");
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <RouteTracker />
      <div className="app-container">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route
            path="/checkout"
            element={<CheckoutPage setOrderDetails={setOrderDetails} />}
          />
          <Route
            path="/thank-you"
            element={
              orderDetails ? (
                <ThankYouPage orderDetails={orderDetails} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          {/* Redirect */}
          <Route path="/admin" element={<Navigate to="/admin/login" />} />
          
          {/* Fallback route - redirect to home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
